/**
 * Je používateľ obchodníkom (contractor) firmy viazanej na tiket?
 */
export function isTicketCompanyContractor(ticket, user) {
  if (!ticket || !user) return false;
  const userId = Number(user.id);
  if (!Number.isFinite(userId) || userId <= 0) return false;

  const primaryContractor = Number(ticket?.primary_company?.contractor_id ?? ticket?.primaryCompany?.contractor_id);
  if (Number.isFinite(primaryContractor) && primaryContractor === userId) {
    return true;
  }

  const recipients = Array.isArray(ticket?.recipients) ? ticket.recipients : [];
  return recipients.some((row) => {
    const contractorId = Number(row?.company?.contractor_id ?? row?.contractor_id);
    return Number.isFinite(contractorId) && contractorId === userId;
  });
}
